import React from 'react';
import Entry from '../entry';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { Flex, Text } from 'rebass';

export default () => {
  const title = '9. Retrieve Scraps of Paper from Server';
  const flag = 'Super Sled-o-matic';
  const hints = [(<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Pepper Minstix] </Text><a rel="noopener noreferrer" target="_blank" href='https://pen-testing.sans.org/blog/2017/10/13/sqlmap-tamper-scripts-for-the-win'>SqlMap Tamper Scripts</a></Flex>),
   (<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Pepper Minstix] </Text><a rel="noopener noreferrer" target="_blank" href='https://www.owasp.org/index.php/SQL_Injection'>SQL Injection from OWASP</a></Flex>),
 `[Pepper Minstix Chat] Have you had any luck retrieving scraps of paper from the Elf U server?
You might want to look into SQL injection techniques.
OWASP is always a good resource for web attacks.
For blind SQLi, I've heard Sqlmap is a great tool.
In certain circumstances though, you need custom tamper scripts to get things going!`,
`[Krampus Chat] As for those scraps of paper, I scanned those and put the images on my server.
I then threw the paper away.
Unfortunately, I managed to lock out my account on the server.
Hey! You’ve got some great skills. Would you please hack into my system and retrieve the scans?
I give you permission to hack into it, solving Objective 9 in your badge.`];
  const assignment = 'Gain access to the data on the Student Portal server and retrieve the paper scraps hosted there. What is the name of Santa\'s cutting-edge sleigh guidance system? For hints on achieving this objective, please visit the dorm and talk with Pepper Minstix.'
  const data = useStaticQuery(graphql`
    query {
      piecesTogether: file(relativePath: { eq: "piecesTogether.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      dbs: file(relativePath: { eq: "dbs.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      tables: file(relativePath: { eq: "tables.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      dump: file(relativePath: { eq: "dump.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      getImage: file(relativePath: { eq: "getImage.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      slashKramp: file(relativePath: { eq: "slashKramp.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      chng: file(relativePath: { eq: "change.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      lolErr: file(relativePath: { eq: "errLol.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      kErr: file(relativePath: { eq: "errKramp.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      congr: file(relativePath: { eq: "congr.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      token: file(relativePath: { eq: "tokenPhp.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code9url: file(relativePath: { eq: "code9url.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code9addtamper: file(relativePath: { eq: "code9addtamper.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code9docker: file(relativePath: { eq: "code9docker.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code9finalcommand: file(relativePath: { eq: "code9finalcommand.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code9tamperscript: file(relativePath: { eq: "code9tamperscript.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }

    }
  `)
  return (
    <Entry
      title={title}
      hints={hints}
      flag={flag}
      assignment={assignment}
    >
      <Text my={2}> Krampus gave us explicit permission to hack https://studentportal.elfu.org/ and retrieve images. Let's explore the website.</Text>
      <Img fluid={data.slashKramp.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '40vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>When we check application status, we want to be able to enter any type of text to see what happens. Let's change the type of input for elfmail in browser Dev Tools from <code>email</code> to <code>text</code>. </Text>
      <Img fluid={data.chng.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '40vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>If we enter <code>zz</code> as an email to check, it redirects is to an weird looking url: </Text>
      <Img fluid={data.code9url.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '40vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>Let's investigate in browser Dev Tools where the token comes from.</Text>
      <Img fluid={data.token.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '50vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>Looks like the browser makes a request to <code>https://studentportal.elfu.org/validator.php</code> to get the token before submission. Continue to experiment with email field, enter <code>' union select * from lol # </code> as elfmail, and an error is diplayed! </Text>
      <Img fluid={data.lolErr.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '40vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>It means that the DB name is <code>elfu</code>. What if we try krampus? <code>' union select * from krampus #</code> results in a different error! </Text>
      <Img fluid={data.kErr.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '40vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>This error means that such table exists, but has different number of columns. So we will target database <code>elfu</code>, table <code>krampus</code>.</Text>
      <Text my={2}>How about hex encoded XSS payload and an email that gives an error. Entering <code>d@efe.com' union select 0x3c696d67207372633d78206f6e6572726f723d636f6e6669726d282f5853532f293e #</code> gives us this.</Text>
      <Img fluid={data.congr.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '40vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text mt={3} mb={2}>Well, OK. Time to fire up SqlMap. To use it on Mac I will use Kali docker image.</Text>
      <Img fluid={data.code9docker.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '40vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>A valid token need to be attached to every SqlMap request. Good thing we know where it comes from! Whatever goes after <code>&token=</code> needs to be urlencoded, as well as the elfmail itself. We will need a custom tamper script.</Text>
      <Img fluid={data.code9addtamper.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '20vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>Paste the tamper script to lol.py</Text>
      <Img fluid={data.code9tamperscript.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>In our SqlMap command we will use tamper module <code>lol</code>, target database <code>elfu</code> table <code>krampus</code>. Url encoding needs to be skipped because we encode things in a custom way in our tamper script. Also, from our previous experiments we know that Union based  and Error based sqli techniques work. </Text>
      <Img fluid={data.code9finalcommand.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '40vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>It worked!</Text>
      <Img fluid={data.dump.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '40vh', maxWidth: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>Each image can be downloaded from the browser.</Text>
      <Img fluid={data.getImage.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>In Keynote we put all the pieces together:</Text>
      <Img fluid={data.piecesTogether.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '70vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text mt={2}>The tooth! A big hint at the Tooth Fairy.</Text>
    </Entry>
  )

};
